"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfoBlockGroupSchema = void 0;
exports.InfoBlockGroupSchema = {
    "$id": "https://www.redbull.com/schemas/attributes/info-block-group.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "InfoBlockGroup",
    "description": "A list of Info Blocks. Example: a step-by-step guide or a selection of infos that need to be shared with the user in an engaging way.",
    "type": "object",
    "additionalProperties": false,
    "properties": {
        "type": {
            "type": "string",
            "enum": [
                "attributes:info-block-group"
            ]
        },
        "title": {
            "description": "Short title leading into the info block(s) describing their characteristics. Example: Follow these steps to take part",
            "$ref": "https://www.redbull.com/schemas/attributes/text.schema.json"
        },
        "blocks": {
            "description": "List of steps, Items to win, or general information.",
            "type": "array",
            "items": {
                "$ref": "https://www.redbull.com/schemas/attributes/info-block.schema.json"
            }
        }
    },
    "required": [
        "blocks",
        "type"
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5mby1ibG9jay1ncm91cC5zY2hlbWEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvbW9kdWxlcy9hdHRyaWJ1dGVzL2luZm8tYmxvY2stZ3JvdXAuc2NoZW1hLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFhLFFBQUEsb0JBQW9CLEdBQUc7SUFDbEMsS0FBSyxFQUFFLHlFQUF5RTtJQUNoRixTQUFTLEVBQUUsOENBQThDO0lBQ3pELE9BQU8sRUFBRSxnQkFBZ0I7SUFDekIsYUFBYSxFQUFFLHVJQUF1STtJQUN0SixNQUFNLEVBQUUsUUFBUTtJQUNoQixzQkFBc0IsRUFBRSxLQUFLO0lBQzdCLFlBQVksRUFBRTtRQUNaLE1BQU0sRUFBRTtZQUNOLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLE1BQU0sRUFBRTtnQkFDTiw2QkFBNkI7YUFDOUI7U0FDRjtRQUNELE9BQU8sRUFBRTtZQUNQLGFBQWEsRUFBRSx1SEFBdUg7WUFDdEksTUFBTSxFQUFFLDZEQUE2RDtTQUN0RTtRQUNELFFBQVEsRUFBRTtZQUNSLGFBQWEsRUFBRSxzREFBc0Q7WUFDckUsTUFBTSxFQUFFLE9BQU87WUFDZixPQUFPLEVBQUU7Z0JBQ1AsTUFBTSxFQUFFLG1FQUFtRTthQUM1RTtTQUNGO0tBQ0Y7SUFDRCxVQUFVLEVBQUU7UUFDVixRQUFRO1FBQ1IsTUFBTTtLQUNQO0NBQ0YsQ0FBQSJ9